/**
 * Convert an ISO timestamp into a short, human-friendly relative string.
 * Returns "—" for empty/missing values.
 */
export function formatStaleness(iso) {
  if (!iso) return "—";
  const ms = Date.now() - new Date(iso).getTime();
  if (Number.isNaN(ms)) return "—";
  const h = ms / 3.6e6;
  if (h < 1) return `${Math.max(1, Math.round(ms / 6e4))}m ago`;
  if (h < 24) return `${Math.round(h)}h ago`;
  const d = Math.round(h / 24);
  return `${d}d ago`;
}

/**
 * Returns true when the given ISO timestamp is older than `days` days.
 */
export function isStale(iso, days = 7) {
  if (!iso) return false;
  return Date.now() - new Date(iso).getTime() > days * 24 * 3.6e6;
}
